/* 
Object:         User Profile (Password change)
Description:    Logic and events for the module User Profile (Password Change)
Used in:        UserProfile
*/

import * as viewmode from "../viewmode";


/**
* Init (binding button actions)
*/
export function initialize(readonly: boolean): void {

    if (readonly) {
        viewmode.disableAllInputs("ChangePasswordForm");
    }
}

/**
* Checks Passwordfield and Pasword2 field have identical values.
* Is called on leaving Password2 field.
*/
export function onPassword2Field(e: kendo.ui.TextBoxEvent): void {

    const valNewPw = $("#Password").val();

    if (e.sender.value() != valNewPw) {
        // We could write something in screen
        // $('#Validation').text();
    }
}
